import { render, staticRenderFns } from "./ESGScopeTableByNameTemp.vue?vue&type=template&id=422b1cfd"
import script from "./ESGScopeTableByNameTemp.vue?vue&type=script&lang=js"
export * from "./ESGScopeTableByNameTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports